import $ from 'jquery';
import 'jquery.easing';

const $secondaryNav = $('.secondary-nav');
const $secondaryNavSelect = $('.secondary-nav-select');

// Mobile dropdown functionality
// ------------------------------------------------------------------------ //
$secondaryNavSelect.each((_, el) => {
  const $el = $(el);
  const $btn = $el.find('.secondary-nav-btn');
  const $dropDown = $el.find('.secondary-nav-drop-down');
  let isOpen = false;

  function closeDropDown() {
    isOpen = false;
    // Animate the height of the drop down
    $dropDown.animate({ height: 0 }, 250, 'easeInOutQuad', () => {
      // Move drop down off screen
      $el.removeClass('is-open');
      // clear out the inline styles so things work responsively
      $dropDown.attr('style', '');
    });
  }

  function openDropDown() {
    isOpen = true;
    // Get height of drop down
    // (which is absolutely positioned off the left of the screen)
    const height = $dropDown.outerHeight();
    // Make height 0
    $dropDown.css('height', 0);
    // Bring drop down onto the screen
    $el.addClass('is-open');
    // Animate the height of the drop down
    $dropDown.animate({ height }, 250, 'easeInOutQuad', () => {
      // clear out the inline styles so things work responsively
      $dropDown.attr('style', '');
    });
  }

  function toggleDropDown() {
    if (isOpen) {
      closeDropDown();
    } else {
      openDropDown();
    }
  }

  $btn.click(e => {
    e.preventDefault();
    toggleDropDown();
  });

  $btn.on('blur', () => {
    closeDropDown();
  });
});

// Sticky Nav functionality
// ------------------------------------------------------------------------ //
$secondaryNav.each((i, el) => {
  const $el = $(el);
  const $body = $el.find('.secondary-nav-body');
  const $window = $(window);
  let isSticky = false;
  let bottomEdge = $el.offset().top + $body.height();

  function stick() {
    isSticky = true;
    $el.addClass('is-sticky');
  }

  function unStick() {
    isSticky = false;
    $el.removeClass('is-sticky');
  }

  function checkScrollPosition() {
    if ($window.scrollTop() > bottomEdge) {
      if (isSticky === false) {
        stick();
      }
    } else if (isSticky) {
      unStick();
    }
  }

  $window.on('scroll', () => {
    checkScrollPosition();
  });

  $window.on('resize', () => {
    bottomEdge = $el.offset().top + $body.height();
  });

  checkScrollPosition();
});
